/* eslint-disable import/no-unresolved */
import Snackbar from "@mui/material/Snackbar";
import React from "react";
import Alert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";

function ErrorBox() {
  const open = useSelector((state: any) => state.toast_error.error);
  const message = useSelector((state: any) => state.toast_error.message);
  const type = useSelector((state: any) => state.toast_error.type);
  const duration = useSelector((state: any) => state.toast_error.duration);
  const dispatch = useDispatch();
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return null;
    }
    return dispatch(SET_TOAST_ERROR({ error: false, message: "", type }));
  };
  return (
    <Snackbar
      open={open}
      autoHideDuration={duration || 2000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={type || "error"}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default ErrorBox;
